export const contactStrings = {
    en:{
        contactTitle1:"Contact",
        contactTitle2:"Get in Touch",
        contactPhone: "Phone",
        contactSendMeANote: "Send me a note",
        contactPlaceholderName: "Name",
        contactPlaceholderEmail: "Email",
        contactPlaceholderContent: "Tell me about your needs...",
        contactButtonTitle: "Wyślij wiadomość",
        contactSending: "Sending message...",
        contactSendingSuccess: "Message sent successfully! Wait for quick reply ;)",
        contactSendingError: "Something went wrong. The message ",
        validationNameRequired: "Please enter your name.",
        validationEmailRequired: "Please enter your email address.",
        validationEmailInvalid: "Please enter a valid email address.",
        validationMessageRequired: "Please describe your needs (at least 10 characters).",
    },
    pl: {
        contactTitle1:"Kontakt",
        contactTitle2:"Złapmy się",
        contactPhone: "Telefon",
        contactSendMeANote: "Wyślij mi wiadomość",
        contactPlaceholderName: "Imię i nazwisko",
        contactPlaceholderEmail: "E-mail",
        contactPlaceholderContent: "Napisz czego potrzebujesz...",
        contactButtonTitle: "Wyślij wiadomość",
        contactSending: "Wysyłanie wiadomości...",
        contactSendingSuccess: "Wiadomość została wysłana! Oczekuj szybkiej odpowiedzi ;)",
        contactSendingError: "Niestety nie udało się wysłać wiadomości.",
        validationNameRequired: "Podaj swoje imię i nazwisko.",
        validationEmailRequired: "Podaj adres e-mail.",
        validationEmailInvalid: "Podaj prawidłowy adres e-mail.",
        validationMessageRequired: "Opisz swoje potrzeby (minimum 10 znaków).",
    },
};

export default contactStrings;